import type { SVGProps } from "react";
const SvgTraveller = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16 12.5c0-1.9 0-2.8-.6-3.4s-1.5-.6-3.4-.6-2.8 0-3.4.6-.6 1.5-.6 3.4V14c0 1 0 1.4.3 1.7s.8.3 1.7.3v4c0 1 0 1.4.3 1.7s.8.3 1.7.3c1 0 1.4 0 1.7-.3s.3-.8.3-1.7v-4c1 0 1.4 0 1.7-.3s.3-.8.3-1.7z"
    />
  </svg>
);
export default SvgTraveller;
